$(window).on('load', function(){
    const bookingButton = $('button[data-cal-link]');
    $(bookingButton).on('click', function() {
        _learnq.push(['track', 'Booking Started'])
    })
});
